import {Category} from "./category";
export class Query {
  id: number = 0;
  results:object[]=[];   //list to display
  set:Category = null;         //Chosen item
  choose:boolean=false;
  name:  string = "Top Level";
  parent: Query;
  show:boolean = false;
  close:Function;
  wide: boolean = false;

  clear(){
    this.set = null;
    this.results=[];
    this.show=false;
}

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }


}




// WEBPACK FOOTER //
// ./src/app/category/query.ts